import { SphereTooltip } from "@components/common/sphere-tooltip";
import { blue, neutral } from "@flat-ui";
import { Box, SvgIcon } from "@mui/material";
import { EDecimalToHex } from "@styles/common-colors";
import { addTransparency, getSvgColoredIconCss } from "@utils/ui-utils";

/** The color for the box shadow in the view mode item */
const BOX_SHADOW_COLOR = addTransparency({
  color: neutral[0],
  alpha: EDecimalToHex.twenty,
});

interface Props {
  /** Title to display in the tooltip */
  tooltipTitle: string;

  /** The icon component to show */
  component: React.ElementType;

  /** Whether the view mode is active */
  isActive?: boolean;

  /** Callback fired when: the view mode item is clicked */
  onClick?: () => void;
}

/**
 * Displays an item of the view mode selector
 */
export function ViewModeSelectorItem({
  isActive,
  component,
  tooltipTitle,
  onClick,
}: Props): JSX.Element {
  return (
    <SphereTooltip title={tooltipTitle}>
      <Box
        component="div"
        sx={{
          backgroundColor: isActive ? neutral[0] : undefined,
          borderRadius: "4px",
          width: "42px",
          height: "30px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: isActive ? `0px 1px 2px ${BOX_SHADOW_COLOR}` : undefined,
          "&:hover": {
            cursor: isActive ? "default" : "pointer",
          },
          ...getSvgColoredIconCss(isActive ? blue[500] : neutral[800]),
        }}
        onClick={isActive ? undefined : onClick}
      >
        <SvgIcon
          inheritViewBox={true}
          component={component}
          sx={{
            width: "18px",
            height: "18px",

            // Hides background rectangles/utility layers within the Map icon from the Design System.
            // The SVG loader adds a unique prefix (e.g., 'map-large_svg__') to classes,
            // so we use a partial attribute selector to target them.
            "& [class*='map-large-1']": {
              display: "none",
            },
          }}
        />
      </Box>
    </SphereTooltip>
  );
}
